/**
 * @desc 子iframe页面 ->  父页面的通信
 */
import PostMessage from '@umu/umu-post-message';
import {
    SessionMessageAction,
    IIframeMessageData,
    IIframeACKParentModel,
    IIframeACKChild,
    CourseShareTypes,
} from '../messageActions';
import { isInIframe } from '@umu/umu-dom';
import { BasePostControlManager } from './basePostControl';

const log = (...args: any[]) => {
    console.log('iframe lib child', ...args);
};
const inFrame = isInIframe();
const TimeoutMessage = 20000;
export interface IBlockGoOtherSessionDialogOptions {
    title?: string;
    content?: string;
    okText?: string;
    cancelText?: string;
    onOk?: boolean;
    onCancel?: boolean;
}
class PostChildControlManager extends BasePostControlManager {
    public isInited: boolean = false;
    public postMessageInstance: PostMessage | undefined = undefined;
    public parentLocationPromise: Promise<string> | undefined;
    public listenParentLocationPromise: Promise<IIframeACKParentModel> | undefined = undefined;
    // 父子通信的首次握手 alias for listenParentLocationPromise
    public childParentReadyPromise: Promise<IIframeACKParentModel> | undefined = undefined;
    private triggerlistenParentReady: (() => void) | undefined = undefined;
    public parentLocation: string = '';
    constructor() {
        super();
        if (inFrame) {
            // 利用promise特性，将parent的信息取值一次到后，后续不会再执行，无论中间发生多少次destroy和init
            this.listenParentLocationPromise = new Promise((resolve, reject) => {
                let hasResolved = false;
                // 15s后timeout reject
                const timer = setTimeout(() => {
                    if (!hasResolved) {
                        reject();
                    }
                }, TimeoutMessage);
                let timeOutId = timer;
                this.triggerlistenParentReady = () => {
                    if (timeOutId) {
                        clearTimeout(timeOutId);
                    }
                    hasResolved = true;
                    resolve(undefined);
                };
            }).then(() => {
                const payload: IIframeACKChild = {
                    action: SessionMessageAction.get_parentUrl,
                    data: {
                        url: window.location.href,
                    },
                };
                log('child sendMsg:', payload);

                this.sendMsg(payload);
                return this._listenParentLocationPromise();
            }) as Promise<IIframeACKParentModel>;
            this.childParentReadyPromise = this.listenParentLocationPromise;
        }
        this.init();
    }
    /**
     * 获取 domain 以设置 postmessage
     */
    getDomain = () => {
        const host = window.location.host;
        const protocol = window.location.protocol;
        // const domain =
        //     protocol +
        //        //        //     '//' +
        //        //     (host.indexOf('test') > -1 ? 'test.' : '') +
        //     host.replace('test.', '').replace('m.', '').replace('www.', '').replace('dev.', '');

        const isDev = host.indexOf('m.dev') > -1;
        const domain =
            protocol +
            (isDev ? '//' : '//www.') +
            (host.indexOf('test') > -1 ? 'test.' : '') +
            host.replace('test.', '').replace('m.', '').replace('www.', '').replace('dev.', '');

        return domain;
    };
    /**
     * 初始化接收到数据的回调函数
     * @param {any} config domain, receiver, etc.
     */
    init = () => {
        if (!inFrame || this.isInited) {
            return;
        }
        // 监听父容器发来的数据
        const config = {
            domain: this.getDomain(),
            receiver: window.parent,
        };
        this.isInited = true;
        this.postMessageInstance = new PostMessage(config);
        this.triggerlistenParentReady && this.triggerlistenParentReady();
    };
    _listenParentLocationPromise(): Promise<IIframeACKParentModel> {
        // 保持监听能力
        return new Promise((res) => {
            // remove timeout，处理任何的响应态
            // const timer = setTimeout(() => {
            //     rej(`parent timeout sendback event:${SessionMessageAction.get_parentUrl} to child`)
            // }, TimeoutMessage);
            this.onMessage((payload: IIframeMessageData<SessionMessageAction, any>) => {
                if (payload && payload.action === SessionMessageAction.get_parentUrl) {
                    const parentLocation = payload?.data;
                    this.parentLocation = parentLocation;
                    // clearTimeout(timer);
                    res(parentLocation);
                    log('iframe child onMessage--', payload.action, SessionMessageAction.get_parentUrl, payload);
                }
            });
        });
    }

    sendGotoPrevCourse(payload?: any) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.up_go_prev_course,
            data: payload,
        });
    }

    sendGotoNextCourse(payload?: any) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.up_go_next_course,
            data: payload,
        });
    }

    sendShareCourse(payload: { id: number; type: CourseShareTypes }) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.up_share_course,
            data: payload,
        });
    }

    /**
     * 控制父级目录的折叠显示隐藏
     * @param isOpen {boolean}
     * @param withFoldBtn {boolean} 是否控制折叠按钮的隐藏显示
     */
    sendSideBarFold(isOpen: boolean, withFoldBtn: boolean) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.up_fold_parent_sidebar,
            data: {
                open: isOpen,
                withFoldBtn,
            },
        });
    }

    /**
     * 阻止跳转到其他小节
     * @param dialogOptions {IBlockGoOtherSessionDialogOptions}
     * @param dialogOptions.title {string} 弹窗标题
     * @param dialogOptions.content {string} 弹窗内容
     * @param dialogOptions.okText {string} 弹窗确认按钮文案
     * @param dialogOptions.cancelText {string} 弹窗取消按钮文案
     * @param dialogOptions.onOk {() => void} 弹窗确认按钮回调
     * @param dialogOptions.onCancel {() => void} 弹窗取消按钮回调
     */
    blockGoOtherSession(dialogOptions: IBlockGoOtherSessionDialogOptions) {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.block_go_other_session,
            data: {
                block: true,
                dialogOptions,
            },
        });
    }

    /**
     * 允许跳转到其他小节
     */
    unlockGoOtherSession() {
        if (!this.isInited) {
            return;
        }
        this.sendMsg({
            action: SessionMessageAction.unblock_go_other_session,
            data: {
                block: false,
            },
        });
    }
}

export const childPostControl = new PostChildControlManager();
